import { Outlet } from 'react-router-dom'
import { InputsFormularioFeedbackProvider } from '../../../contexts/InputsContext/InputsFormularioFeedBackContext'

export const FeedbackLayout = (): JSX.Element => {
  return (
    <InputsFormularioFeedbackProvider>
      <Outlet />
    </InputsFormularioFeedbackProvider>
  )
}
